import { CloseCircleOutlined } from "@ant-design/icons";
import { Divider, Modal } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMobile } from "../../../../context/MobileContext";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { envChangeType } from "../../../../plugins/utils";
import { useGetMyProjectDetail } from "../../hooks/index.hook";
import styles from "./style.module.scss";
import "./style.scss";

const DetailModal = ({ targetData, open, setOpen, showDivider = true }) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  const { data: detailData, isFetching } = useGetMyProjectDetail({
    options: { enabled: !!targetData && open },
    params: { user_facility_id: targetData?.id },
  });

  const describeEnum = [
    {
      label: t("project.detail.price"),
      needCurrency: true,
      value: moneyFormat(detailData?.msg?.uni_price),
    },
    {
      label: t("project.detail.id"),
      needCurrency: false,
      value: detailData?.data?.data[0].no,
    },
    {
      label: t("project.detail.status"),
      needCurrency: false,
      value: detailData?.data?.data[0].bonus_status_text,
    },
    {
      label: t("project.detail.income"),
      needCurrency: true,
      value: moneyFormat(detailData?.data?.data[0].all_total_bonus),
    },
  ];

  const handleClickOk = () => {
    setOpen(false);
  };

  useEffect(() => {
    console.log("detailData", detailData);
    console.log("targetData", targetData);
  }, [detailData, targetData]);

  return (
    <Modal
      title={targetData?.name}
      open={open}
      onOk={handleClickOk}
      width={isMobile ? 358 : 700}
      onCancel={() => setOpen(false)}
      closeIcon={<CloseCircleOutlined className={styles.close} />}
      wrapClassName="detail-modal"
      destroyOnClose={true}
      loading={isFetching}
      footer={[
        <div key="footer" className={styles.footer}>
          <div>{t("project.detail.accumulated")}</div>
          <div>
            {moneyFormat(detailData?.msg?.all_total_bonus) +
              " " +
              t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)}
          </div>
        </div>,
        <div
          className="contract"
          dangerouslySetInnerHTML={{ __html: detailData?.data?.data[0].contract }}
        />,
      ]}
    >
      <div className={styles.describeContainer}>
        {showDivider && <Divider className={styles.divider} />}
        {describeEnum.map((describe, index) => {
          return (
            <div className={styles.describe} key={index}>
              <div className={styles.label}>{describe.label}</div>
              <div className={styles.value}>
                {describe.value +
                  " " +
                  (describe.needCurrency
                    ? t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`)
                    : "")}
              </div>
            </div>
          );
        })}
        {showDivider && <Divider className={styles.divider} />}
      </div>
    </Modal>
  );
};

export default DetailModal;
